const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function isDateOnlyString(value: string): boolean {
  return DATE_ONLY_RE.test(value);
}

/** Local Calendar selection → YYYY-MM-DD (no timezone shift on the wire). */
export function localDateToIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** YYYY-MM-DD or API datetime → local midnight Date for PrimeVue Calendar. */
export function parseCalendarDateToLocalDate(value: string): Date {
  if (isDateOnlyString(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const parsed = new Date(value);
  return new Date(
    parsed.getFullYear(),
    parsed.getMonth(),
    parsed.getDate(),
  );
}

/** GraphQL / API value → YYYY-MM-DD for forms and REST bodies. */
export function calendarDateFromApi(value: string): string {
  if (isDateOnlyString(value)) {
    return value;
  }
  return localDateToIsoDate(parseCalendarDateToLocalDate(value));
}

/** Calendar-day fields (e.g. best-before): format YYYY-MM-DD as DD.MM.YYYY without timezone shift. */
export function formatCalendarDateDE(dateStr: string): string {
  const [y, m, d] = dateStr.slice(0, 10).split('-');
  if (!y || !m || !d) return dateStr;
  return `${d}.${m}.${y}`;
}

/**
 * German display date. Date-only values (YYYY-MM-DD) keep their calendar day;
 * datetimes are formatted in the local timezone.
 */
export function formatDisplayDateDE(value: string): string {
  if (isDateOnlyString(value)) {
    return formatCalendarDateDE(value);
  }
  return new Date(value).toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}
